import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}admin/getdata/get_pendingbooking.php`;

const PendingBooking = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [updateData, setUpdateData] = useState({
    checkin_date: "",
    checkout_date: "",
    status: "confirm",
    room_id: "",
    noof_room: 1,
  });

  /* ================= FETCH BOOKINGS ================= */
  const fetchBooking = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.get(API_URL, {
        params: {
          action: "list",
          fromDate,
          toDate,
        },
      });

      if (Array.isArray(res.data)) {
        // show only pending bookings
        setBookings(res.data.filter(b => b.status === "pendings"));
      } else {
        setBookings([]);
      }
    } catch (err) {
      console.error(err);
      setMessage("Error loading bookings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooking();
  }, []);

  /* ================= OPEN CONFIRM MODAL ================= */
  const openConfirmModal = (booking) => {
    setSelectedBooking(booking);
    setUpdateData({
      checkin_date: booking.checkin_date,
      checkout_date: booking.checkout_date,
      status: "confirm",
      room_id: booking.roomId,
      noof_room: booking.noof_room,
    });
    setShowModal(true);
  };

  /* ================= DELETE BOOKING ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this booking?")) return;

    try {
      const res = await axios.post(`${API_URL}?action=delete`, { id });

      if (res.data?.status === "success") {
        setMessage("Booking deleted successfully");
        fetchBooking();
      } else {
        setMessage(res.data?.message || "Delete failed");
      }
    } catch (err) {
      console.error(err);
      setMessage("Delete failed");
    }
  };

  /* ================= CONFIRM BOOKING ================= */
  const handleConfirmBooking = async () => {
    if (updateData.checkout_date <= updateData.checkin_date) {
      alert("Check-out date must be after check-in date");
      return;
    }

    if (!updateData.room_id) {
      alert("Room ID missing");
      return;
    }

    try {
      const res = await axios.post(
        `${API_URL}?action=confirm`,
        {
          id: selectedBooking.id,
          roomId: updateData.room_id, // backend expects roomId
          noof_room: updateData.noof_room,
          checkin_date: updateData.checkin_date,
          checkout_date: updateData.checkout_date,
          status: "confirm", // FORCE confirm
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "success") {
        alert("Booking confirmed successfully");
        setShowModal(false);
        setSelectedBooking(null);
        fetchBooking();
      } else {
        alert(res.data.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />

      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="widget-list">

            <h4 className="mb-3">Pending Room Bookings</h4>

            {/* FILTER */}
            <div className="card">
              <div className="card-body">
                {message && <div className="alert alert-info py-2">{message}</div>}

                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3 d-flex align-items-end">
                    <button
                      className="btn btn-primary w-100"
                      onClick={fetchBooking}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Filter"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* LIST */}
            <div className="card mt-4">
              <div className="card-header">View Pending Bookings</div>

              <div className="card-body p-0">
                {loading ? (
                  <p className="p-3 mb-0">Loading...</p>
                ) : (
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Summary</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Check-in</th>
                        <th>Check-out</th>
                        <th>Rooms</th>
                        <th>Total Price</th>
                        <th>Status</th>
                        <th colSpan={2}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {bookings.length > 0 ? (
                        bookings.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                              <td>{item.summary}</td>
                            <td>{item.name}</td>
                            <td>{item.phone}</td>
                            <td>{item.checkin_date}</td>
                            <td>{item.checkout_date}</td>
                            <td>{item.noof_room}</td>
                            <td>₹{item.total_price}</td>
                            <td>
                              <span className="badge bg-warning">Pending</span>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-success me-2"
                                onClick={() => openConfirmModal(item)}
                              >
                                ✔ Confirm
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(item.id)}
                              >
                                🗑 Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No pending bookings found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

          </div>
        </main>

        <Footer />

        {/* CONFIRM MODAL */}
        {showModal && (
          <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Confirm Booking</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>

                <div className="modal-body">
                  <p><strong>Name:</strong> {selectedBooking?.name}</p>
                  <p><strong>Phone:</strong> {selectedBooking?.phone}</p>
                  <p><strong>Rooms:</strong> {updateData.noof_room}</p>

                  <div className="mb-3">
                    <label className="form-label">Check-in Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={updateData.checkin_date}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, checkin_date: e.target.value })
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Check-out Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={updateData.checkout_date}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, checkout_date: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-success" onClick={handleConfirmBooking}>
                    Save & Confirm
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default PendingBooking;
